import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { DocumentState } from './state';

const defaultState: DocumentState = {
  third_party_payment: undefined,
  document_templates: [],
};

export const documentModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
